import { memo } from "react";

type LastUserMessageProps = {
  text: string;
};

export const LastUserMessage = memo(function LastUserMessage({
  text,
}: LastUserMessageProps) {
  return (
    <div className={`w-full mb-4 flex items-start justify-end`}>
      <p
        className={`inline-block pt-3 pr-3 pb-3 pl-[23px] bg-[#191919] text-white rounded-tl-[50px] rounded-tr-[20px] rounded-bl-[50px] [@media(max-width:440px)]:text-[13px]`}
      >
        {text}
      </p>
    </div>
  );
});
